import React, { useEffect } from 'react';
import Spinner from '@atlaskit/spinner';
import { CardContent, CardHeader, CardWrapper, LoadingWrapper } from '../../styled/TeamCard';
import { profileCardRendered } from '../../util/analytics';
export default (function (props) {
  var analytics = props.analytics;
  useEffect(function () {
    analytics(function (duration) {
      return profileCardRendered('team', 'spinner', {
        duration: duration
      });
    });
  }, [analytics]);
  return /*#__PURE__*/React.createElement(CardWrapper, {
    "data-testid": "team-profilecard"
  }, /*#__PURE__*/React.createElement(CardHeader, {
    isLoading: true
  }), /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(LoadingWrapper, {
    "data-testid": "team-profilecard-spinner"
  }, /*#__PURE__*/React.createElement(Spinner, null))));
});